import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

type OrganizationBookingPolicyEditorProps = {
  value: string;
  onChange: (html: string) => void;
};

export default function OrganizationBookingPolicyEditor({ value, onChange }: OrganizationBookingPolicyEditorProps) {
  return (
    <div className="[&_.ql-container]:min-h-[200px] [&_.ql-editor]:min-h-[180px] [&_.ql-toolbar]:rounded-t-lg [&_.ql-container]:rounded-b-lg border border-border overflow-hidden bg-bgContainer">
      <ReactQuill theme="snow" value={value} onChange={onChange} modules={modules} />
    </div>
  );
}
